/** @module csi/property/View */
define([
	"dojo/_base/declare",
	"lodash",
	"csi/def",
	"csi/def/View",
	"csi/def/Heading",
	"csi/util",
], function(declare, _, def, View, Heading, util) {

	return declare(View, {
		supportsImageLabels: true,

		/** @property {string[]} optionalAttributesPaths - paths from which to retrieve attribute groups - as of 7.9.1, only needed for migration purposes from previous releases */
		optionalAttributesPaths: null,

		/** @property {boolean} supportsAttributeGroups - set to false if attribute groups are not to be processed */
		supportsAttributeGroups: true,

		/** @property {boolean} useDefaultCard - if use default card to generate headings */
		useDefaultCard: true,

		constructor(xn) {
			this.m_nColumns = Number(util.getProperty(xn, "Columns", 0));
			this.m_images = util.getDefs(xn, "Image", Heading);
			this.m_imageDefault = util.getProperty(util.ssn(xn, "Image"), "ImageDefault");
			this.m_headings = util.getDefs(xn, "Heading|Card", Heading) || [];
			this.optionalAttributesPaths = util.getProperty(xn, "OptionalAttributesPath")?.split(",");
			this.useDefaultCard = util.getBooleanProperty(xn, "UseDefaultCard", true);
		},

		/**
		 * Property view only supports one image
		 * @return {Heading | undefined}
		 */
		getImage() {
			return this.m_images?.[0];
		},

		resolve: function(/*Class*/rcRoot, /*Node*/nodeRoot, /*Boolean*/bConfigure) {
			// summary: resolve view
			this.populateHeadingsFromCards(rcRoot, this.pathHintsContext);
			return this.inherited(arguments);
		},

		populateHeadingsFromCards(rcRoot, pathHints) {
			// if no headings, then add default Card to see if it can be resolved
			if (_.isEmpty(this.m_headings) && rcRoot && this.useDefaultCard) {
				this.m_headings = [
					Object.assign(this.newHeading(), {
						m_bCard: true,
						m_id: def.getDefaultCardId(rcRoot.getType())
					})
				];
			}
			this.inherited(arguments);
		},
	});
});